'use strict';exports.__esModule = true;
var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _reactRedux = require('react-redux');
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _reactHelmet = require('react-helmet');var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
var _classnames = require('classnames');var _classnames2 = _interopRequireDefault(_classnames);
var _debounce = require('lodash/debounce');var _debounce2 = _interopRequireDefault(_debounce);
var _reactRouter = require('react-router');
var _get = require('lodash/get');var _get2 = _interopRequireDefault(_get);

var _containers = require('../../containers');
var _components = require('../../components');








var _checkUserAgent = require('../../utils/checkUserAgent');var _checkUserAgent2 = _interopRequireDefault(_checkUserAgent);
var _analyticsConstants = require('../../utils/analytics/analyticsConstants');
var _constants = require('../../constants');






var _multiLanguageHeadTags = require('../../helpers/multiLanguageHeadTags');var _multiLanguageHeadTags2 = _interopRequireDefault(_multiLanguageHeadTags);
var _appendLocale = require('../../helpers/appendLocale');var _appendLocale2 = _interopRequireDefault(_appendLocale);

var _HomePage = require('./HomePage.scss');var styles = _interopRequireWildcard(_HomePage);
var _devices = require('../../../static/icons/devices.svg');var _devices2 = _interopRequireDefault(_devices);
var _HomePageCitiesLinks = require('../HomePageCitiesLinks/HomePageCitiesLinks');var _HomePageCitiesLinks2 = _interopRequireDefault(_HomePageCitiesLinks);
var _WhatsAppWidget = require('../WhatsAppWidget/WhatsAppWidget');var _WhatsAppWidget2 = _interopRequireDefault(_WhatsAppWidget);
var _beautifyNumber = require('../../helpers/beautifyNumber');var _beautifyNumber2 = _interopRequireDefault(_beautifyNumber);
var _helpers = require('./helpers');
var _formatRecentSearchData = require('../../utils/formatRecentSearchData');var _formatRecentSearchData2 = _interopRequireDefault(_formatRecentSearchData);
var _analytics = require('./analytics');function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;} // Modules
// Component
// Helpers
// Styles
var













HomePage = function (_Component) {_inherits(HomePage, _Component);
  function HomePage(props) {_classCallCheck(this, HomePage);var _this = _possibleConstructorReturn(this,
    _Component.call(this, props));_this.

































    setScreenWidth = function () {return _this.setState({ screenWidth: _this.getScreenWidth() });};_this.
    getScreenWidth = function () {return global && global.document && global.document.body.clientWidth || 0;};_this.

    getCitiesLinksTitle = function (type) {
      var localizedType = _this.props.translate('SEOsearch', 'optionType', type).toString();
      var title = _this.props.translate('homePage', 'morePropertiesFor').replace(/%s/g, localizedType);
      return title;
    };_this.

    handlePublishClick = function (evt) {
      (0, _analytics.sendAnalytics)(_analyticsConstants.eventLabel.publishBanner);
      var regular = (0, _get2.default)(_this.props.userData, 'publish_permissions.regular');
      var foreign = (0, _get2.default)(_this.props.userData, 'publish_permissions.foreign');

      var canPublish = _this.props.publishClicked(evt);

      if (canPublish) {
        _reactRouter.browserHistory.push((0, _appendLocale2.default)(_this.props.locale, !regular && foreign ? '/foreign_publish' : '/publish'));
      }
    };_this.

    handleClickLink = function (link) {return _reactRouter.browserHistory.push((0, _appendLocale2.default)(_this.props.locale, link));};_this.

    renderAppLinks = function () {return !_this.props.isMobile &&
      _react2.default.createElement('div', { className: styles.applications },
        _react2.default.createElement('img', { src: _devices2.default, alt: '' }),
        _react2.default.createElement('div', { className: styles.appTitle }, _this.props.langStatic('downloadApps').toUpperCase()),
        _react2.default.createElement('div', { className: styles.appIcons },
          _react2.default.createElement('a', { href: _constants.appStoreLink, target: '_blank', rel: 'nofollow noopener noreferrer', onClick: _analytics.trackApplicationsClick },
            _react2.default.createElement('span', { className: 'icon icon-apple' }),
            _react2.default.createElement('span', null, 'iOS')), '\xA0\xA0\xA0',


          _react2.default.createElement('a', { href: _constants.playmarketLink, target: '_blank', rel: 'nofollow noopener noreferrer', onClick: _analytics.trackApplicationsClick },
            _react2.default.createElement('span', { className: 'icon icon-android' }),
            _react2.default.createElement('span', null, 'Android'))));};_this.state = { screenWidth: 0, isMobileOrTablet: _checkUserAgent2.default.isMobileOrTablet(navigator.userAgent), citiesForSale: (0, _helpers.getCitiesLinksValues)(props.locale, 'buy'), citiesForRent: (0, _helpers.getCitiesLinksValues)(props.locale, 'rent') };_this.setScreenWidth = (0, _debounce2.default)(_this.setScreenWidth, 250);return _this;}HomePage.prototype.componentWillMount = function componentWillMount() {this.isIOsDevice = !!_checkUserAgent2.default.getIOsVersion(navigator.userAgent);};HomePage.prototype.componentDidMount = function componentDidMount() {this.setScreenWidth();window.addEventListener('resize', this.setScreenWidth);};HomePage.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {if (nextProps.locale !== this.props.locale) {this.setState({ citiesForSale: (0, _helpers.getCitiesLinksValues)(nextProps.locale, 'buy'), citiesForRent: (0, _helpers.getCitiesLinksValues)(nextProps.locale, 'rent') });}};HomePage.prototype.componentWillUnmount = function componentWillUnmount() {this.setScreenWidth.cancel();window.removeEventListener('resize', this.setScreenWidth);};HomePage.prototype.





  render = function render() {var _this2 = this;var _props =
    this.props,isMobile = _props.isMobile,route = _props.route,locale = _props.locale,langStatic = _props.langStatic,userData = _props.userData,isNative = _props.isNative;
    var multiLanguage = (0, _multiLanguageHeadTags2.default)(route, locale);
    var regular = (0, _get2.default)(userData, 'publish_permissions.regular');
    var foreign = (0, _get2.default)(userData, 'publish_permissions.foreign');

    return (
      _react2.default.createElement('div', { className: styles.home },
        _react2.default.createElement(_reactHelmet2.default, {
          titleTemplate: this.props.langStatic('title', 'titleTemplate')(),
          title: this.props.langStatic('title', 'home')(),
          link: [].concat(
          multiLanguage, [
          { rel: 'canonical', href: '' + _constants.shareUrl + (route === _helpers.ROOT_ROUTE ? '' : route) }]),

          meta: [
          { property: 'og:url', content: '' + _constants.shareUrl + (route === _helpers.ROOT_ROUTE ? '' : route) },
          { property: 'og:description', content: this.props.langStatic('helmet', 'homeOGDescription') },
          { property: 'og:title', content: this.props.langStatic('helmet', 'homeTitle') + ' | \u202BOnMap' },
          { name: 'description', content: this.props.langStatic('helmet', 'homeDescription') }] }),


        _react2.default.createElement('div', { className: styles.wrapperTop },
          _react2.default.createElement('div', {
              className: styles.masthead,
              ref: function ref(videoContainer) {_this2.videoContainer = videoContainer;} },

            _react2.default.createElement(_components.Video, {
              isMobileOrTablet: this.state.isMobileOrTablet,
              isMobile: this.props.isMobile,
              publishClicked: this.props.publishClicked,
              locale: this.props.locale }),


            this.renderAppLinks(),

            _react2.default.createElement('div', { className: styles.wrapperSearch },
              _react2.default.createElement('div', { className: styles.title }, _react2.default.createElement('span', null, this.props.langStatic('residence_main_promotion')), ' ', _react2.default.createElement('span', { className: styles.titleLogo }, 'OnMap')),
              _react2.default.createElement(_containers.SearchBoxContainer, {
                isMobile: isMobile,
                locale: this.props.locale,
                translate: this.props.langStatic('search_box'),
                rootTranslate: this.props.langStatic,
                isShown: !isMobile,
                route: this.props.route,
                propertyTypes: this.props.propertyTypes }))),



          this.props.isMobile &&
          _react2.default.createElement(_components.AdGoToForeignMainPage, {
            translate: this.props.langStatic,
            locale: this.props.locale }),


          !!this.props.resentSearches.length &&
          _react2.default.createElement('div', { className: (0, _classnames2.default)(styles.benefits), onClick: _analytics.trackRecentSearches },
            _react2.default.createElement('span', { className: styles.blockTitle }, langStatic('homePage', 'recentSearches')),
            _react2.default.createElement(_components.HomePagePropertiesChips, {
              name: 'home-page-recent-searches',
              values: (0, _formatRecentSearchData2.default)(this.props.resentSearches, locale, langStatic),
              onChange: this.handleClickLink })),




          !!this.props.favoriteIDs.length &&
          _react2.default.createElement('div', { className: (0, _classnames2.default)(styles.benefits, styles.carousel), onClick: _analytics.trackFavorites },
            _react2.default.createElement('span', { className: styles.blockTitle }, langStatic('homePage', 'favoriteProperties')),
            _react2.default.createElement(_containers.HomePagePropertiesContainer, {
              screenWidth: this.state.screenWidth,
              carouselType: _constants.propertiesSlidersTypes.FAVORITES,
              isFavorites: true })),




          _react2.default.createElement('div', { className: (0, _classnames2.default)(styles.benefits, styles.carousel), onClick: _analytics.trackNewPropertiesForSale },
            _react2.default.createElement('h1', null, langStatic('homePage', 'newPropertiesForSale')),
            _react2.default.createElement(_containers.HomePagePropertiesContainer, {
              screenWidth: this.state.screenWidth,
              carouselType: _constants.propertiesSlidersTypes.FOR_SALE })),



          _react2.default.createElement('div', { className: (0, _classnames2.default)(styles.benefits, styles.additionalRow), onClick: _analytics.trackMorePropertiesForSaleIn },
            _react2.default.createElement('div', { className: styles.subTitle }, this.getCitiesLinksTitle(_constants.propertiesSlidersTypes.FOR_SALE)),
            _react2.default.createElement(_components.HomePagePropertiesChips, {
              name: 'home-page-cities-links',
              values: this.state.citiesForSale,
              onChange: this.handleClickLink,
              className: 'solid' })),



          _react2.default.createElement('div', {
              className: (0, _classnames2.default)(styles.benefits, styles.darkBackground, styles.carousel),
              onClick: _analytics.trackNewPropertiesForRent },

            _react2.default.createElement('h2', null, langStatic('homePage', 'newPropertiesForRent')),
            _react2.default.createElement(_containers.HomePagePropertiesContainer, {
              screenWidth: this.state.screenWidth,
              carouselType: _constants.propertiesSlidersTypes.FOR_RENT })),



          _react2.default.createElement('div', {
              className: (0, _classnames2.default)(styles.benefits, styles.additionalRow, styles.darkBackground),
              onClick: _analytics.trackMorePropertiesForRentIn },

            _react2.default.createElement('div', { className: styles.subTitle }, this.getCitiesLinksTitle(_constants.propertiesSlidersTypes.FOR_RENT)),
            _react2.default.createElement(_components.HomePagePropertiesChips, {
              name: 'home-page-cities-links',
              values: this.state.citiesForRent,
              onChange: this.handleClickLink,
              className: 'solid' })),



          _react2.default.createElement('div', { className: (0, _classnames2.default)(styles.benefits, styles.carousel), onClick: _analytics.trackNewHomes },
            _react2.default.createElement('span', { className: styles.blockTitle }, langStatic('header', 'projects')),
            _react2.default.createElement(_containers.HomePagePropertiesContainer, {
              screenWidth: this.state.screenWidth,
              carouselType: _constants.propertiesSlidersTypes.PROJECTS,
              isProjects: true })),



          _react2.default.createElement('div', { className: styles.additionalSpace }),

          _react2.default.createElement('div', { className: styles.homeBanner },
            _react2.default.createElement('img', { src: _constants.homePageHomeBanner, alt: '' }),
            _react2.default.createElement('div', null,
              _react2.default.createElement('div', null, langStatic('homePage', 'freePublish')),
              _react2.default.createElement(_components.PublishPropertyButton, {
                title: '' + langStatic('header', 'publishProperty'),
                theme: !regular && foreign ? 'foreign' : 'primary',
                size: 'large',
                additionalStylingTheme: 'boldBorder',
                onClick: this.handlePublishClick }))),




          _react2.default.createElement('div', {
              className: (0, _classnames2.default)(styles.benefits, styles.bottomPadded, styles.carousel),
              onClick: _analytics.trackPropertiesUnderMillion },

            _react2.default.createElement('span', { className: styles.blockTitle }, langStatic('homePage', 'propertiesUnder'), '\xA0\u20AA', (0, _beautifyNumber2.default)(_helpers.MAX_PRICE_FOR_CAROUSEL)),
            _react2.default.createElement(_containers.HomePagePropertiesContainer, {
              screenWidth: this.state.screenWidth,
              carouselType: _constants.propertiesSlidersTypes.UP_TO,
              additionalFilters: { max: _helpers.MAX_PRICE_FOR_CAROUSEL } })),



          _react2.default.createElement('div', {
              className: (0, _classnames2.default)(styles.benefits, styles.darkBackground, styles.bottomPadded, styles.carousel),
              onClick: _analytics.trackPropertiesByTypes },

            _react2.default.createElement(_containers.HomePagePropertiesContainer, {
              screenWidth: this.state.screenWidth,
              carouselType: _constants.propertiesSlidersTypes.PROPERTY_TYPE,
              withPropertyTypesFilter: true })),



          _react2.default.createElement('div', { className: (0, _classnames2.default)(styles.benefits, styles.bottomPadded, styles.carousel), onClick: _analytics.trackProfessionals },
            _react2.default.createElement('div', { className: styles.professionalsTitle },
              _react2.default.createElement('span', { className: styles.blockTitle }, langStatic('homePage', 'popularProfessionals')),
              _react2.default.createElement(_reactRouter.Link, { to: (0, _appendLocale2.default)(locale, '/contact_us_realtor'), onClick: _analytics.trackProfessionalsJoin }, langStatic('homePage', 'joinFree'))),

            _react2.default.createElement(_containers.ProfessionalsCarouselContainer, { screenWidth: this.state.screenWidth })),


          this.props.isMobile &&
          _react2.default.createElement('div', { className: styles.mobileAppBanner },
            _react2.default.createElement('img', { src: _devices2.default, alt: '' }),
            _react2.default.createElement('div', { className: styles.appTitle }, this.props.langStatic('downloadApps').toUpperCase()),

            _react2.default.createElement('a', { href: this.isIOsDevice ? _constants.appStoreLink : _constants.playmarketLink, target: '_blank', rel: 'nofollow noopener noreferrer' },
              _react2.default.createElement('span', { className: 'icon icon-' + (this.isIOsDevice ? 'apple' : 'android') }), '\xA0\xA0',
              _react2.default.createElement('span', null, this.props.langStatic('homePage', 'download' + (this.isIOsDevice ? 'Apple' : 'Android'))))),




          _react2.default.createElement('hr', { className: styles.divider }),

          _react2.default.createElement('div', { className: (0, _classnames2.default)(styles.benefits, styles.filtersLinksBlock), onClick: _analytics.trackPropertiesForSaleUnder },
            _react2.default.createElement('span', { className: styles.blockTitle }, langStatic('homePage', 'salesByPrice')),
            _react2.default.createElement(_components.HomePagePropertiesChips, {
              name: 'home-page-price-links',
              values: _helpers.getPriceFilterLinks,
              onChange: this.handleClickLink })),



          _react2.default.createElement('div', {
              className: (0, _classnames2.default)(styles.benefits, styles.filtersLinksBlock, styles.bottomPadded),
              onClick: _analytics.trackPropertiesForSaleByRooms },

            _react2.default.createElement('span', { className: styles.blockTitle }, langStatic('homePage', 'salesByRooms')),
            _react2.default.createElement(_components.HomePagePropertiesChips, {
              name: 'home-page-rooms-links',
              values: (0, _helpers.getRoomFilterLinks)(langStatic),
              onChange: this.handleClickLink })),



          _react2.default.createElement('hr', { className: styles.divider }),

          _react2.default.createElement(_components.SiteDescription, {
            title: this.props.langStatic('title', 'description').toString(),
            locale: this.props.locale }),


          _react2.default.createElement('div', { className: styles.citiesLinks },
            _react2.default.createElement(_HomePageCitiesLinks2.default, {
              locale: this.props.locale,
              translate: this.props.langStatic,
              citiesData: this.props.citiesLinksData,
              optionType: 'buy' }),

            _react2.default.createElement(_HomePageCitiesLinks2.default, {
              locale: this.props.locale,
              translate: this.props.langStatic,
              citiesData: this.props.citiesLinksData,
              optionType: 'rent' }))),



        _react2.default.createElement(_WhatsAppWidget2.default, { translate: this.props.translate }),
        !isNative && _react2.default.createElement(_components.BTHNCounter, { lang: this.props.locale })));


  };return HomePage;}(_react.Component);


HomePage.propTypes = {
  locale: _propTypes2.default.string.isRequired,
  route: _propTypes2.default.string.isRequired,
  translate: _propTypes2.default.func,
  isMobile: _propTypes2.default.bool,
  isNative: _propTypes2.default.bool,
  langStatic: _propTypes2.default.func,
  openMobileFilters: _propTypes2.default.func,
  publishClicked: _propTypes2.default.func,
  majorCitiesData: _propTypes2.default.array,
  citiesLinksData: _propTypes2.default.array,
  resentSearches: _propTypes2.default.array,
  favoriteIDs: _propTypes2.default.array,
  propertyTypes: _propTypes2.default.object,
  userData: _propTypes2.default.object,
  location: _propTypes2.default.object.isRequired };


var mapStateToProps = function mapStateToProps(state) {return {
    isNative: state.native.isNative };};exports.default =


(0, _reactRedux.connect)(mapStateToProps)(
HomePage);module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/HomePage/HomePage.js
// module id = 1210
// module chunks = 0